/**
 * Campaign lifecycle statuses
 */
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus[CampaignStatus["PendingReview"] = 1] = "PendingReview";
    CampaignStatus[CampaignStatus["PendingSetup"] = 2] = "PendingSetup";
    CampaignStatus[CampaignStatus["PendingActivation"] = 3] = "PendingActivation";
    CampaignStatus[CampaignStatus["InProgress"] = 4] = "InProgress";
    CampaignStatus[CampaignStatus["Paused"] = 5] = "Paused";
    CampaignStatus[CampaignStatus["Done"] = 6] = "Done";
    CampaignStatus[CampaignStatus["Validated"] = 7] = "Validated";
    CampaignStatus[CampaignStatus["Discarded"] = 8] = "Discarded";
})(CampaignStatus || (CampaignStatus = {}));
export const CampaignStatusLabels = {
    [CampaignStatus.PendingReview]: 'Pending Review',
    [CampaignStatus.PendingSetup]: 'Pending Setup',
    [CampaignStatus.PendingActivation]: 'Pending Activation',
    [CampaignStatus.InProgress]: 'In Progress',
    [CampaignStatus.Paused]: 'Paused',
    [CampaignStatus.Done]: 'Done',
    [CampaignStatus.Validated]: 'Validated',
    [CampaignStatus.Discarded]: 'Discarded',
};
/**
 * Parse status string from BigQuery (e.g., "4.- In Progress") to CampaignStatus enum
 */
export function parseStatusString(statusStr) {
    if (!statusStr)
        return CampaignStatus.PendingReview;
    const match = statusStr.match(/^(\d+)/);
    if (match) {
        const code = parseInt(match[1], 10);
        if (code in CampaignStatusLabels)
            return code;
    }
    return CampaignStatus.PendingReview;
}
/**
 * Build the raw advia-os status string (e.g. "4.- In Progress") from a
 * CampaignStatus. Inverse of parseStatusString — advia-os stores the status
 * as a "<code>.- <Label>" string, so this is the canonical format to write
 * back when updating a record.
 */
export function buildStatusString(status) {
    return `${status}.- ${CampaignStatusLabels[status]}`;
}
//# sourceMappingURL=campaign.js.map